import { render, staticRenderFns } from "./EditEmailTemplate.vue?vue&type=template&id=06324904&scoped=true"
import script from "./EditEmailTemplate.vue?vue&type=script&lang=js"
export * from "./EditEmailTemplate.vue?vue&type=script&lang=js"
import style0 from "./EditEmailTemplate.vue?vue&type=style&index=0&id=06324904&prod&lang=scss&scoped=true"
import style1 from "./EditEmailTemplate.vue?vue&type=style&index=1&id=06324904&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06324904",
  null
  
)

export default component.exports